<template>
	<ValidationProvider :vid="idLabel" slim>
		<div class="radio radio abc-radio">
			<input
				class="form-check-input"
				type="radio"
				:name="group"
				:id="$id('radio-input')"
				:value="keyValue"
				@change="$emit('input', keyValue)"
				:checked="value === keyValue"
			/>
			<label class="form-check-label" :for="$id('radio-input')">{{ label }}</label>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';

export default {
	mixins: [formControlProps, validationProps],

	props: ['label', 'value', 'checkedValue', 'group'],

	computed: {
		keyValue() {
			return this.checkedValue !== undefined ? this.checkedValue : this.label;
		},
	},

	components: {
		ValidationProvider,
	},
};
</script>
